import React from 'react';
import PropTypes from 'prop-types';

const style = {
  position: 'relative',
  marginTop: 50,
  width: 100,
  height: 100,
  background: '#1EAAE5',
  transform: 'rotate(-45deg)',
};

const AnalysesIcon = ({ icon, title }) => {
  return (
    <div>
      <div style={style}>
        <div
          style={{
            position: 'absolute',
            width: 63,
            left: 0,
            top: 18,
            left: 17,
            transform: 'rotate(45deg)',
            color: 'white',
          }}
        >
          <i
            className="material-icons"
            style={{
              fontSize: 60,
            }}
          >
            {icon}
          </i>
        </div>
      </div>
      <div
        style={{
          marginTop: 50,
          fontFamily: 'Roboto',
          fontSize: 20,
          fontWeight: 'bold',
        }}
      >
        {title}
      </div>
    </div>
  );
};

AnalysesIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default AnalysesIcon;



// WEBPACK FOOTER //
// ./src/components/Main/services/AnalysesIcon.js